import { useMutation } from '@gogame/query';

import { updateComment } from 'scenes/Gallery/GalleryPage/Concepts/Comments/sources/comments';

import { update, commentsQuery } from '../queryKeyFactory';

export const useUpdate = () => {
  const updateMutation = useMutation(update(), updateComment, {
    refreshOptions: {
      queryKey: commentsQuery.all(),
    },
  });

  return [updateMutation.mutateAsync, updateMutation];
};
